import { render, staticRenderFns } from "./kc-zy-show.vue?vue&type=template&id=0ad6058f&scoped=true"
import script from "./kc-zy-show.vue?vue&type=script&lang=js"
export * from "./kc-zy-show.vue?vue&type=script&lang=js"
import style0 from "./kc-zy-show.vue?vue&type=style&index=0&id=0ad6058f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad6058f",
  null
  
)

export default component.exports